/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiCoilStatusModel } from '../../models/api-coil-status-model';

export interface GetCoilStatus$Params {
  systemSerialNumber: string;
  systemMaterialNumber: number;
}

export function getCoilStatus(http: HttpClient, rootUrl: string, params: GetCoilStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiCoilStatusModel>> {
  const rb = new RequestBuilder(rootUrl, getCoilStatus.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiCoilStatusModel>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getCoilStatus.PATH = '/api/CoilAsync/coilstatus/{systemSerialNumber}/{systemMaterialNumber}';
getCoilStatus.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getCoilStatus.ROOTURL = '/coil';
